import { render, staticRenderFns } from "./RealTimeOptions.vue?vue&type=template&id=ffabd9b8&scoped=true"
import script from "./RealTimeOptions.vue?vue&type=script&lang=ts"
export * from "./RealTimeOptions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffabd9b8",
  null
  
)

export default component.exports